import { forEach } from 'lodash';

import API from '~config/api';
import {
  ApiPromise,
  PaginationRequestParams,
  DataPaginateResponse,
  DataResponse,
  ErrorResponse,
  FileObj,
} from '~globals/types';

import {
  AdminVehicle,
  AdminVehicleCreateBody,
  AdminVehicleFilter,
  AdminVehicleUpdateBody,
  AdminVehicleImporter,
} from './types';

export const ADMIN_VEHCILE_ENPOINTS = {
  createAdminVehicle: '/api/v1/Admin/Vehicle',
  getAdminVehicleById: (vehicleId: string): string =>
    `/api/v1/Admin/Vehicle/${vehicleId}`,
  searchAdminVehicles: '/api/v1/Admin/Vehicle/search',
  updateAdminVehicle: '/api/v1/Admin/Vehicle',
  deleteAdminVehicle: (vehicleId: string): string =>
    `/api/v1/Admin/Vehicle/${vehicleId}`,
  getTemplateCSV: '/api/v1/Admin/Vehicle/ImportFromCSV/Template',
  importVehiclesByCSV: '/api/v1/Admin/Vehicle/ImportFromCSV',
};

export const createAdminVehicle = (
  body: AdminVehicleCreateBody,
): ApiPromise<DataResponse<AdminVehicle>, ErrorResponse> =>
  API.post<DataResponse<AdminVehicle>, ErrorResponse>(
    ADMIN_VEHCILE_ENPOINTS.createAdminVehicle,
    body,
  );

export const getAdminVehicleById = (
  vehicleId: string,
): ApiPromise<DataResponse<AdminVehicle>, ErrorResponse> =>
  API.get<DataResponse<AdminVehicle>, ErrorResponse>(
    ADMIN_VEHCILE_ENPOINTS.getAdminVehicleById(vehicleId),
  );

export const searchAdminVehicles = ({
  pagination: { page, sizePerPage },
  filters,
}: PaginationRequestParams<AdminVehicleFilter>): ApiPromise<
  DataPaginateResponse<AdminVehicle[]>,
  ErrorResponse
> =>
  API.post<DataPaginateResponse<AdminVehicle[]>, ErrorResponse>(
    ADMIN_VEHCILE_ENPOINTS.searchAdminVehicles,
    { ...filters, pagination: { offset: page, size: sizePerPage } },
  );

export const updateAdminVehicle = (
  body: AdminVehicleUpdateBody,
): ApiPromise<DataResponse<AdminVehicle>, ErrorResponse> =>
  API.put<DataResponse<AdminVehicle>, ErrorResponse>(
    ADMIN_VEHCILE_ENPOINTS.updateAdminVehicle,
    body,
  );

export const deleteAdminVehicle = (
  vehicleId: string,
): ApiPromise<DataResponse<AdminVehicle>, ErrorResponse> =>
  API.delete<DataResponse<AdminVehicle>, ErrorResponse>(
    ADMIN_VEHCILE_ENPOINTS.deleteAdminVehicle(vehicleId),
  );

export const importVehiclesByCSV = (
  files: FileObj[],
): ApiPromise<DataResponse<AdminVehicleImporter>, ErrorResponse> => {
  const formData = new FormData();

  forEach(files, (item) => {
    formData.append('formFile', item.file, item.file.name);
  });

  return API.post<DataResponse<AdminVehicleImporter>, ErrorResponse>(
    ADMIN_VEHCILE_ENPOINTS.importVehiclesByCSV,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    },
  );
};
